<mat-table #sort="matSort" matSort [dataSource]="dataSource" multiTemplateDataRows>

  <!--Primary Table Columns on main Datasource-->
  @for (columnName of tableCols; track columnName; let i = $index) {
    <ng-container matColumnDef="{{columnName}}">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{columnName}}
      </mat-header-cell>
      <mat-cell *matCellDef="let entity"
        style="max-height: 100px; overflow: auto; display: table-row;">
        <span class="mobile-label">{{columnName}}:</span>
        {{ entity[columnName] }}
      </mat-cell>
    </ng-container>
  }

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <mat-cell *matCellDef="let entity" [attr.colspan]="tableCols.length"
      [@detailExpand]="checkExpanded(entity) ? 'expanded' : 'collapsed'"
      style="max-height: fit-content; 
      word-wrap: initial;
      display: table-cell;
      vertical-align: middle;
      ">
      <div class="example-element-detail">
        @if (entity.additionalData) {
          <div class="example-element-description">
            @if (entity.additionalDataIsArray) {
              <div>
                {{entity.additionalData}}
              </div>
            } @else {
              {{entity.additionalData[entity.additionalProperty]}}
            }
          </div>
        } @else {
          <div class="example-element-description">
            @for (item of items; track item) {
              <button mat-button (click)="emitAction(item, entity)">
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.name }}</span>
              </button>
            }
            <!-- No additional entity data -->
          </div>
        }
      </div>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="tableCols"></mat-header-row>
  <mat-row *matRowDef="let row; columns: tableCols" matRipple class="example-element-row"
    [class.example-expanded-row]="checkExpanded(row)" (click)="pushPopElement(row)">
  </mat-row>
  <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"
  [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'"></mat-row>
</mat-table>

<div style="display: flex; align-items: center;">
  <mat-paginator #paginator style="flex: 1 1 auto;" [pageSize]="20" [pageSizeOptions]="[1, 2, 3, 5, 10, 20]"
    showFirstLastButtons>
  </mat-paginator>
  <button mat-icon-button color="primary" matTooltip="Download CSV" (click)="exportCsv(dataSource.data, csv)">
    <mat-icon>get_app</mat-icon>
  </button>
</div>